import styled from "styled-components";
import { transparentize } from "polished";

import theme from "config/theme";

import { H4 } from "components/Text";

export const Wrapper = styled.div`
  display: block;
  margin: 10px;
  padding: 0 30px 15px;
  overflow: hidden;
  box-shadow: 0 1px 4px 0 ${transparentize(0.95, theme.color.gray2)},
    0 3px 25px 0 ${transparentize(0.92, theme.color.gray2)};
  border-radius: ${theme.radius};
  background-color: white;
  text-align: left;
  min-height: 370px;
  position: relative;
`;

export const Title = styled(H4)`
  line-height: 1.3;
  width: 100%;
`;

export const Summary = styled.p`
  font-size: ${theme.font.size.epsilon};
  color: ${theme.color.gray2};
  line-height: 1.6;
`;

export const Icon = styled.img`
  width: 45px;
  height: 45px;
  margin: 20px 0;
`;

export const Text = styled.div`
  font-size: ${theme.font.size.epsilon};
  color: ${theme.color.gray2};
  line-height: 1.6;
`;

export const Count = styled.span`
  display: inline-block;
  line-height: 1;
  text-align: center;
  font-weight: ${theme.font.weight.bold};
  font-size: ${theme.font.size.theta};
  color: ${theme.color.primary};
  background-color: ${transparentize(0.93, theme.color.primary)};
  padding: 8px 18px 8px 10px;
  border-radius: ${theme.radius} 0 0 ${theme.radius};

  position: absolute;
  right: 0;
  top: 15px;
`;
